module.exports = __webpack_public_path__ + "static/img/jbeykh.c7e590a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/jbeykh.png
// module id = 1225
// module chunks = 0